import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class RouterService {
	constructor(private readonly router: Router) {}

	back(target) {
		if (history.length > 2) {
			history.back();
			return;
		}
		this.router.navigate(target);
	}

	navigate(target) {
		this.router.navigate(target);
	}
}
